module.exports = __webpack_public_path__ + "img/5.82ddfabd.png";